import React from 'react'
import { Breakpoint, Modal, Space } from 'antd'

type Props = {
    title?: React.ReactNode;
    children?: React.ReactNode;
    footer?: React.ReactNode;
    isOpen?: boolean;
    loading?: boolean;
    onClose?: () => void;
    maskClosable?: boolean;
    width?: string | number | Partial<Record<Breakpoint, string | number>> | undefined;
    centered?: boolean;
}

const ModalComp: React.FC<Props> = ({
    title = '',
    footer = null,
    children = null,
    isOpen = true,
    loading = false,
    onClose = () => { console.log('Modal closed') },
    maskClosable = false,
    centered = false,
    width = {
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%',
    }
}: Props) => {
    return (
        <Modal
            title={title}
            centered={centered}
            open={isOpen}
            closable={true}
            footer={<Space>{footer}</Space>}
            maskClosable={maskClosable}
            loading={loading}
            onClose={onClose}
            onCancel={onClose}
            width={width}
        >
            {children}
        </Modal>
    )
}

export default ModalComp